import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import Login from './Login.js';
import Dashboard from './Dashboard.js';
import Menu from './Menu.js';
import '../styles/styles.css';

export default class Facil extends Component {
    constructor(props){
        super(props);
        this.state ={};
    }

    render() {
        return (
            <main>
                <Switch>
                    <Route exact path='/' component={Login}/>
                    <Route exact path='/menu' component={Menu}/>
                    <Route path='/dashboard' component={Dashboard}/>
                </Switch>
            </main>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Facil.js